module.exports = __webpack_public_path__ + "img/number.9c47f364.png";